module.exports = __webpack_public_path__ + "static/media/review3.d5c6a3f1.svg";